import { getPageFromName } from "../../route_utils";
import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import api_endpoints from "../../api";
import AuthContext from "../../context/AuthContext/AuthContext";
import { useSuccessAlert } from "../../context/SuccessAlertContext/SuccessAlertContext";
import AddIcon from "@mui/icons-material/Add";
import { NavigationButton } from "../../widgets/NavigationButton/NavigationButton";
import CustomTextField from "../../widgets/CustomTextField/CustomTextField";
import { useCustomTranslation } from "../../hooks/useCustomTranslation";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LoadingContainer from "../LoadingContainer/LoadingContainer";
import {
  useTheme,
  Card,
  CardContent,
  Avatar,
  Typography,
  Grid,
} from "@mui/material";
import Box from "@mui/material/Box";
import { useApiClientQuery } from "../../hooks/useApiClient";

const ManageKiosks = () => {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { t } = useCustomTranslation("Kiosks");
  const theme = useTheme();

  // Two-fields search: kioskname + location
  const [searchFilter, setSearchFilter] = useState({
    organization_id: authContext.authContext.accessToken.organization_id,
    kioskname: "",
    location: "",
  });

  const kiosksQuery = useApiClientQuery(
    () =>
      api_endpoints.getKiosks(
        searchFilter.organization_id,
        searchFilter.kioskname, // name filter
        searchFilter.location   // location filter
      ),
    {
      queryKey: [
        "manage_kiosks",
        searchFilter.organization_id,
        searchFilter.kioskname,
        searchFilter.location,
      ],
    }
  );

  const changeSearchFilter = (option, value) => {
    setSearchFilter((prevFilter) => ({ ...prevFilter, [option]: value }));
  };

  const clearSearchFilter = (option) => {
    setSearchFilter((prevFilter) => ({ ...prevFilter, [option]: "" }));
  };

  const showKioskDetails = (e_id) => {
    navigate(getPageFromName("Modifier un Kiosk").path, {
      state: { kiosk_id: e_id },
    });
  };

  return (
    <>
      <div className={"flex justify-end"}>
        <NavigationButton
          startIcon={<AddIcon />}
          text={t("kiosks_addKiosk_button") ?? "Kiosk"}
          path={getPageFromName("Créer un Kiosk").path}
        />
      </div>

      {/* Two search fields: Name + Location */}
      <div className="container-main !flex-row [&>div]:flex items-end space-x-4 w-full max-w-3xl">
        <div className="flex-1 flex-col">
          <span className="mb-1 block">{t("search")}</span>
          <CustomTextField
            placeholder={t("kiosks_table_name") || "Kiosk Name"}
            value={searchFilter.kioskname}
            onChange={(e) => changeSearchFilter("kioskname", e.target.value)}
            clearFilter={() => clearSearchFilter("kioskname")}
          />
        </div>
        <div className="flex-1 flex-col">
          <span className="mb-1 block">{t("kiosks_table_location") || "Location"}</span>
          <CustomTextField
            placeholder={t("kiosks_table_location") || "Location"}
            value={searchFilter.location}
            onChange={(e) => changeSearchFilter("location", e.target.value)}
            clearFilter={() => clearSearchFilter("location")}
          />
        </div>
      </div>

      <div className="flex flex-1 h-full mt-5 flex-col">
        <LoadingContainer
          loading={kiosksQuery.isLoading}
          error={kiosksQuery.isError}
        >
          <Grid container spacing={2}>
            {kiosksQuery.data && kiosksQuery.data.length > 0 ? (
              kiosksQuery.data.map((kiosk, index) => (
                <Grid
                  item
                  key={kiosk?._id || `kiosk_${index}`}
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                >
                  <Card
                    className="flex h-[120px] w-full transition-transform"
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "scale(1.03)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                    }}
                  >
                    <div
                      className="flex w-full h-full cursor-pointer"
                      onClick={() => showKioskDetails(kiosk._id)}
                    >
                      <CardContent className="flex flex-row items-center space-x-4">
                        <Avatar sx={{ bgcolor: theme.palette.info.main }}>
                          {(kiosk?.name?.[0] || "?").toUpperCase()}
                        </Avatar>
                        <div className="flex flex-1 flex-col [&>label]:text-lg [&>span]:text-gray-500">
                          <span>
                            <Typography
                              variant="h6"
                              component="div"
                              style={{
                                fontWeight: 600,
                                color: "#333",
                                marginBottom: 8,
                              }}
                            >
                              {kiosk?.name}
                            </Typography>
                          </span>
                          <Box display="flex" alignItems="left" justifyContent="left">
                            <LocationOnIcon style={{ color: "#666" }} />
                            <Typography variant="body2" color="text.secondary">
                              {kiosk?.location?.location_name}
                            </Typography>
                          </Box>
                        </div>
                      </CardContent>
                    </div>
                  </Card>
                </Grid>
              ))
            ) : (
              <Grid item xs={12}>
                <Typography variant="h6" align="center">
                  {t("no_kiosk_available")}
                </Typography>
              </Grid>
            )}
          </Grid>
        </LoadingContainer>
      </div>
    </>
  );
};

export default ManageKiosks;
